__turbopack_context__.v({
  "collapsible": "FR_s3W_collapsible",
  "collapsible-container": "FR_s3W_collapsible-container",
  "header": "FR_s3W_header",
  "title": "FR_s3W_title",
  "toggle": "FR_s3W_toggle",
});
